import { ContainerModule } from 'inversify';
import InAppNotificationService from 'src/features/inAppNotifications/data/service/InAppNotificationsService';
import { InAppNotificationsServiceInterface } from 'src/features/inAppNotifications/data/service/InAppNotificationsService.types';
import GetUserNotificationsUseCase from 'src/features/inAppNotifications/domain/useCases/GetUserNotificationsUseCase';
import { GetUserNotificationsUseCaseInterface } from 'src/features/inAppNotifications/domain/useCases/types';
import SlackNotificationsService from 'src/features/slack/data/service/SlackNotificationsService';
import { SlackNotificationsServiceInterface } from 'src/features/slack/data/service/SlackNotificationsService.types';
import SlackNotificationsRepository from 'src/features/slack/data/SlackNotificationsRepository';
import { SlackNotificationsRepositoryInterface } from 'src/features/slack/domain/SlackNotificationsRepositoryInterface';
import SendSlackAppNotificationUseCase from 'src/features/slack/domain/useCases/SendSlackAppNotificationUseCase';

export const notificationsBindings = new ContainerModule((bind) => {
  // Services
  bind<SlackNotificationsServiceInterface>(SlackNotificationsService).to(
    SlackNotificationsService
  );
  bind<InAppNotificationsServiceInterface>(InAppNotificationService).to(
    InAppNotificationService
  );

  // Repositories
  bind<SlackNotificationsRepositoryInterface>(SlackNotificationsRepository).to(
    SlackNotificationsRepository
  );

  // Use cases
  bind<SendSlackAppNotificationUseCase>(SendSlackAppNotificationUseCase).to(
    SendSlackAppNotificationUseCase
  );
  bind<GetUserNotificationsUseCaseInterface>(GetUserNotificationsUseCase).to(
    GetUserNotificationsUseCase
  );
});
